import { ReactNodeViewRenderer } from "@tiptap/react";
import { Node, mergeAttributes } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import ContentBox from "./ContenBox";

const deleteGuardKey = new PluginKey("contentBoxDeleteGuard");

const countContentBoxes = (doc) => {
	let count = 0;
	doc.descendants((n) => {
		if (n.type.name === "contentBox") {
			count += 1;
		}
	});
	return count;
};

const ContentBoxExtention = Node.create({
	name: "contentBox",
	group: "inline",
	inline: true,
	atom: true,
	draggable: true,

	addOptions() {
		return {
			onDeleteAttempt: null,
		};
	},

	addAttributes() {
		return {
			informations: {
				default: [
					{
						content: "",
						documentId: 0,
						documentName: "",
						itemId: 0,
						pageStart: 0,
						refType: "",
					},
				],
				parseHTML: (element) => {
					const data = element.getAttribute("data-informations");
					return data ? JSON.parse(data) : [];
				},
				renderHTML: (attributes) => ({
					"data-informations": JSON.stringify(attributes.informations),
				}),
			},
			size: {
				default: "small",
				parseHTML: (element) => element.getAttribute("data-size") || "small",
				renderHTML: (attributes) => ({
					"data-size": attributes.size,
				}),
			},
		};
	},

	parseHTML() {
		return [{ tag: "content-box" }];
	},

	renderHTML({ HTMLAttributes }) {
		return ["content-box", mergeAttributes(HTMLAttributes)];
	},

	addNodeView() {
		return ReactNodeViewRenderer(ContentBox, {
			contentDOMElementTag: "div",
		});
	},

	addProseMirrorPlugins() {
		const { onDeleteAttempt } = this.options;
		return [
			new Plugin({
				key: deleteGuardKey,
				filterTransaction: (tr, state) => {
					if (!tr.docChanged) {
						return true;
					}
					if (tr.getMeta("contentBoxDeleteConfirmed")) {
						return true;
					}
					if (tr.getMeta("history$")) {
						return true;
					}
					const before = countContentBoxes(state.doc);
					if (before === 0) {
						return true;
					}
					const after = countContentBoxes(tr.doc);
					if (after >= before) {
						return true;
					}
					onDeleteAttempt?.(tr);
					return false;
				},
			}),
		];
	},
});

export default ContentBoxExtention;
